export enum FuelTypeValue {
  Coal = "Coal",
  Electric = "Electric",
  Kerosene = "Kerosene",
  NotListed = "Not Listed",
  Solar = "Solar",
  Wood = "Wood",
}
